var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 212,
    viewBox: "0 0 411 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.721 57.708L406.284 67.5635C405.51 67.2062 387.169 58.7204 370.346 28.7671C365.493 20.1026 358.02 9.97924 350.1 10.9023C344.413 11.5871 329.347 19.6262 312.226 79.92C293.558 145.662 253.6 188.598 193.515 207.564C154.629 219.831 106.513 193.63 104.488 192.528L109.729 183.059C110.324 183.387 155.879 208.1 190.269 197.262C246.692 179.457 284.208 138.993 301.835 76.9723C315.918 27.3677 331.312 2.23782 348.849 0.18337C359.955 -1.12672 370.376 6.70402 379.785 23.4969C394.881 50.3537 410.542 57.6187 410.721 57.708Z",
    fill: "#525460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29838 143.668L37.7928 164.331C40.1748 166.058 40.7107 169.393 38.9838 171.775C37.2568 174.157 33.9221 174.693 31.5401 172.966L3.0457 152.302C0.663725 150.575 0.12778 147.241 1.85471 144.859C3.58164 142.477 6.91641 141.941 9.29838 143.668Z",
    fill: "#525460"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.272 112.017L59.7664 132.681C62.1484 134.408 62.6843 137.743 60.9574 140.125C59.2305 142.507 55.8957 143.043 53.5137 141.316L25.0193 120.652C22.6374 118.925 22.1014 115.59 23.8283 113.208C25.5553 110.826 28.89 110.29 31.272 112.017Z",
    fill: "#525460"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.017 194.225L113.331 196.875L118.244 186.99L134.948 193.6L131.017 194.225Z",
    fill: "#525460"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4424 173.234L60.7492 205.301C77.7803 216.377 100.409 212.804 113.212 196.994C127.504 179.338 124.08 153.285 105.709 139.916L58.9925 105.973L11.4424 173.234Z",
    fill: "#D83E59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4424 173.234L60.7492 205.301C77.7803 216.377 100.409 212.804 113.212 196.994C127.504 179.338 124.08 153.285 105.709 139.916L58.9925 105.973L11.4424 173.234Z",
    fill: "url(#paint0_linear_731_6455)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9971 175.586L39.3412 160.222L97.5805 202.175C97.5805 202.175 83.6162 209.142 67.5378 201.311C51.4893 193.51 27.9971 175.586 27.9971 175.586Z",
    fill: "#D53B5C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_731_6455",
    x1: 11.4424,
    y1: 158.846,
    x2: 121.81,
    y2: 158.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D83E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32C66"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPlug);
export default __webpack_public_path__ + "static/media/RightPlug.3a68d5233ef597aab232c4dbee85a9fb.svg";
export { ForwardRef as ReactComponent };